import { useMutation } from "react-query";
import http from 'infra/http';

function useRejeitarAnuncio() {
  return useMutation(
    `/v1/anuncio/rejeitar`,
    async ({id, motivo}: {id: string; motivo: string}) => {
      const { data } = await http.post<{success: boolean}>(
        `/v1/anuncio/${id}/rejeitar`,
        {motivo}
      );

      return data;
    },
    { retry: false }
  );
}

export default useRejeitarAnuncio;
